export const CITATION_LIMIT_HEADING = 'citation-limit-heading'
export const CREATE_ACCOUNT_MSG = 'create-account-msg'
export const CREATE_ACCOUNT_BTN = 'create-account-btn'
